<div class="editable-table-section mb-4" [class.pt-3]="addTopBorder" [class.border-top]="addTopBorder">
  <div class="d-flex align-items-center justify-content-between mb-2">
    <div class="d-flex align-items-center">
      <button
        type="button"
        class="btn btn-sm btn-link p-0 text-decoration-none me-2"
        (click)="onToggle()"
        [attr.aria-expanded]="expanded">
        <i [class]="expanded ? 'bi bi-chevron-down' : 'bi bi-chevron-right'"></i>
      </button>
      <h6 class="text-muted mb-0">{{ sectionTitle }}</h6>
    </div>
    @if (showEditButton && expanded) {
      <div class="ms-auto">
        @if (editing) {
          <div class="btn-group btn-group-sm" role="group">
            <button type="button" class="btn btn-primary btn-sm" (click)="onAddRow()" title="Add row">
              <i class="bi bi-plus"></i> Add row
            </button>
            <button type="button" class="btn btn-outline-secondary btn-sm" (click)="onCancelEdit()" [disabled]="isSaving">
              <i class="bi bi-x"></i> Cancel
            </button>
            <button type="button" class="btn btn-outline-primary btn-sm" (click)="onSave()" [disabled]="saveDisabled || isSaving">
              @if (isSaving) {
                <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
              } @else {
                <i class="bi bi-check"></i>
              }
              Save
            </button>
          </div>
        } @else {
          <button
            type="button"
            class="btn btn-outline-primary btn-sm"
            (click)="onEnterEdit()"
            [attr.title]="editButtonTitle"
            [attr.aria-label]="editButtonTitle">
            <i class="bi bi-pencil"></i>
          </button>
        }
      </div>
    }
  </div>
  @if (expanded) {
    <div>
      @if (showEditButton && editing) {
        <ng-content select="[editContent]"></ng-content>
        @if (!hasRows && !hasRowsMarkedForDelete) {
          <p class="text-muted mb-0">{{ emptyMessage }}</p>
        }
        @if (!hasRows && hasRowsMarkedForDelete && allRowsDeletedMessage) {
          <p class="text-muted mb-0">{{ allRowsDeletedMessage }}</p>
        }
      } @else {
        <ng-content select="[viewContent]"></ng-content>
        @if (!hasRows && (viewEmptyMessage ?? emptyMessage)) {
          <p class="text-muted mb-0">{{ viewEmptyMessage ?? emptyMessage }}</p>
        }
      }
    </div>
  }
</div>
